import React from 'react';
import { CreditCard, ShieldCheck, Zap, Lock, Check } from 'lucide-react';
export const Offer = () => {
  return <section id="oferta" className="py-14 bg-legal-900 relative" data-id="element-125">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-legal-800 via-legal-900 to-legal-900 pointer-events-none" data-id="element-126"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-127">
        <div className="text-center mb-8" data-id="element-128">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-129">
            Oferta Especial de Hoy
          </h2>
        </div>

        <div className="max-w-lg mx-auto bg-legal-800 rounded-2xl border-2 border-gold-500 shadow-[0_0_40px_rgba(201,162,74,0.15)] overflow-hidden" data-id="element-130">
          <div className="bg-gold-500 py-4 text-center" data-id="element-131">
            <span className="text-legal-900 font-bold uppercase tracking-wider text-sm" data-id="element-132">
              Oferta Especial de Hoy
            </span>
          </div>

          <div className="p-8 md:p-10 text-center" data-id="element-133">
            <p className="text-slate-400 mb-1" data-id="element-134">
              Valor regular:{' '}
              <span className="line-through decoration-gold-500/70 decoration-2" data-id="element-135">
                AR$ 221.430
              </span>
            </p>
            <div className="mb-6 pb-6 border-b border-legal-700" data-id="element-136">
              <p className="text-sm text-slate-400 mb-1" data-id="element-137">Hoy:</p>
              <span className="text-5xl text-white leading-none font-[900] font-[Georgia,_serif]" data-id="element-138">
                $ 27.990
              </span>
            </div>

            <div className="flex items-center justify-center gap-2 text-slate-300 mb-8" data-id="element-139">
              <CreditCard className="w-5 h-5 text-gold-500" data-id="element-140" />
              <span className="font-medium" data-id="element-141">
                3 cuotas sin interés de AR$ 9.330
              </span>
            </div>

            <div className="mb-8 rounded-xl border border-legal-700 bg-legal-900/60 p-5 text-left" data-id="element-142">
              <p className="text-center text-xs font-bold uppercase tracking-widest text-gold-500 mb-4" data-id="element-143">
                Tu compra incluye todo esto
              </p>
              <ul className="space-y-2.5" data-id="element-144">
                <li className="flex items-start gap-2.5 text-sm text-slate-200" data-id="element-145">
                  <Check className="w-4 h-4 text-gold-500 shrink-0 mt-0.5" data-id="element-146" />
                  <span data-id="element-147">
                    <span className="font-semibold text-white" data-id="element-148">
                      Los 6 módulos completos
                    </span>{' '}
                    del Tratado, listos para aplicar desde el primer caso.
                  </span>
                </li>
                <li className="flex items-start gap-2.5 text-sm text-slate-200" data-id="element-149">
                  <Check className="w-4 h-4 text-gold-500 shrink-0 mt-0.5" data-id="element-150" />
                  <span data-id="element-151">
                    <span className="font-semibold text-white" data-id="element-152">
                      Los 4 bonos profesionales
                    </span>{' '}
                    de regalo: modelos, kit para estudios, jurisprudencia y
                    estrategias.
                  </span>
                </li>
                <li className="flex items-start gap-2.5 text-sm text-slate-200" data-id="element-153">
                  <Check className="w-4 h-4 text-gold-500 shrink-0 mt-0.5" data-id="element-154" />
                  <span data-id="element-155">
                    <span className="font-semibold text-white" data-id="element-156">
                      Actualizaciones y acceso de por vida
                    </span>{' '}
                    a todo el material.
                  </span>
                </li>
              </ul>
            </div>

            <a href="https://tratado-practico-de-defensa-del-consumidor.impultienda.ar/checkout" className="block w-full py-5 bg-gold-500 hover:bg-gold-400 text-legal-900 font-bold rounded-xl text-lg md:text-xl text-center transition-all hover:scale-[1.02] active:scale-[0.98] shadow-lg mb-8" data-id="element-157">
              SÍ, QUIERO MI TRATADO AHORA
            </a>

            <div className="space-y-3 text-sm text-slate-400" data-id="element-158">
              <p className="flex items-center justify-center gap-2" data-id="element-159">
                <Lock className="w-4 h-4 text-gold-500" data-id="element-160" />
                Compra 100% segura.
              </p>
              <p className="flex items-center justify-center gap-2" data-id="element-161">
                <Zap className="w-4 h-4 text-gold-500" data-id="element-162" />
                Acceso inmediato.
              </p>
              <p className="flex items-center justify-center gap-2" data-id="element-163">
                <ShieldCheck className="w-4 h-4 text-gold-500" data-id="element-164" />
                Garantía de satisfacción de 7 días.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};